import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-121" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-6xl px-4" data-id="element-122" data-mp="1dx9shrk4eu7v">
        <SectionHeading id="modules-title" data-id="element-123" data-mp="1dudts10g81id">The {totalVolumes} <span className="text-aqua" data-id="element-124" data-mp="2bj7dpwpvxdni">Complete Volumes</span></SectionHeading>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-125" data-mp="26lfdmff36l88">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-xl border border-gray-200 bg-white p-6 shadow-sm" data-id="element-126" data-mp="21o5oz1ziudlg" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-127" data-mp="1nt0k4vfmjna9">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-aqua-soft text-aqua" data-id="element-128" data-mp="18xb3zdx4e4dg">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-129" data-mp="1dvckbr35vpl8" />
                  </span>
                  <p className="text-xs font-semibold uppercase tracking-wider text-gold-dark" data-id="element-130" data-mp="104haocku94gl">Volume {module.number}</p>
                </div>
                <h3 className="mt-4 text-lg font-bold leading-snug text-navy" data-id="element-131" data-mp="14ws9td7r8m83">{module.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-gray-600" data-id="element-132" data-mp="q8e9pa1q3bv8">{module.summary}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}